import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { User } from "../interfaces/UserAuthenticated";
import { dataUserAuthenticated } from "../composables/ExtractDataUser";





const initialValue = ():User => {

    return {
        _id:          "",
        seller_name:  "",
        code_list:    "",
        password:     "",
        email:        "",
        role:        [],
        bearer_token: "",
        cuit: "",
        number_client: 0,
        auth: false,
        api_client: "",
        api_secret: ""
    }
}




export const useUserAuthenticatedStore = defineStore('user-authenticated', () => {

    // PROPERTIES
    const userAuthenticated = ref<User>(initialValue())

    
    // GETTERS
    const getUserAuthenticated = computed(() => userAuthenticated.value)
    const checkUserAuth = computed(() => userAuthenticated.value.auth)
    const getAkeronCredentials = computed(() => {
        return {
            api_client: userAuthenticated.value.api_client,
            api_secret: userAuthenticated.value.api_secret
        }
    })


    // ACTIONS
    const updateUserStore = (user: User) => {
        userAuthenticated.value = {
                ...user,
                auth: true
        }
    }

    // Funcion para limpiar el estado
    const resetUserStore = () => {
        userAuthenticated.value = initialValue()
    }



    // Funcion para actualizar el estado en caso de recargar el navegador.
    const initializeUserStore = async() => {
        
        try {

            const userData = await dataUserAuthenticated();
            
            if(!userData){
                resetUserStore();

            } else {
                updateUserStore(userData);
            }

        } catch (error) {
            resetUserStore();
            console.error('Error al inicializar usuario:', error);
        }
    }


    return {

        // GETTERS
        getUserAuthenticated,
        checkUserAuth,
        getAkeronCredentials,

        //ACTIONS
        updateUserStore,
        resetUserStore,
        initializeUserStore
    }
})